import logBandwangoInstructions from '../mp-help';

const getDefaultState = () => ({});

export default {
  namespaced: true,

  state: () => getDefaultState(),

  actions: {
    setPartnerUser({ commit }, partnerUser) {
      const { email = '' } = partnerUser ?? {};

      if (email && /@bandwango\.com\s*$/.test(email)) {
        logBandwangoInstructions();
      }

      commit('add', partnerUser);
    }
  },

  mutations: {
    add(state, partnerUser) {
      Object.keys(state).forEach(key => {
        delete state[key];
      });

      if (partnerUser && typeof partnerUser === 'object') {
        Object.assign(state, partnerUser);
      }
    }
  }
};
